export const fileConstants = {
  FILE_REQUEST: 'FILE_REQUEST',
  FILE_SUCCESS: 'FILE_SUCCESS',
  FILE_FAILURE: 'FILE_FAILURE',

  FILE_GUID_REQUEST: 'FILE_GUID_REQUEST',
  FILE_GUID_SUCCESS: 'FILE_GUID_SUCCESS',
  FILE_GUID_FAILURE: 'FILE_GUID_FAILURE',

  FILE_INFO_REQUEST: 'FILE_INFO_REQUEST',
  FILE_INFO_SUCCESS: 'FILE_INFO_SUCCESS',
  FILE_INFO_FAILURE: 'FILE_INFO_FAILURE',
  FILE_INFO_RESET: 'FILE_INFO_RESET',

  FILE_CHECK_REQUEST: 'FILE_CHECK_REQUEST',
  FILE_CHECK_SUCCESS: 'FILE_CHECK_SUCCESS',
  FILE_CHECK_FAILURE: 'FILE_CHECK_FAILURE',

  FILE_TEXT_REQUEST: 'FILE_TEXT_REQUEST',
  FILE_TEXT_SUCCESS: 'FILE_TEXT_SUCCESS',
  FILE_TEXT_FAILURE: 'FILE_TEXT_FAILURE',

  FOLIOREMOTE_REQUEST: 'FOLIO_REMOTE_REQUEST',
  FOLIOREMOTE_SUCCESS: 'FOLIO_REMOTE_SUCCESS',
  FOLIOREMOTE_FAILURE: 'FOLIO_REMOTE_FAILURE',

  FOLIO_WF_REQUEST: 'FOLIO_WF_REQUEST',
  FOLIO_WF_SUCCESS: 'FOLIO_WF_SUCCESS',
  FOLIO_WF_FAILURE: 'FOLIO_WF_FAILURE',

  FILECHECKPDF_REQUEST: 'FILECHECKPDF_REQUEST',
  FILECHECKPDF_SUCCESS: 'FILECHECKPDF_SUCCESS',
  FILECHECKPDF_FAILURE: 'FILECHECKPDF_FAILURE',

  FILE_OPTIONS_REQUEST: 'FILE_OPTIONS_REQUEST',
  FILE_OPTIONS_SUCCESS: 'FILE_OPTIONS_SUCCESS',
  FILE_OPTIONS_FAILURE: 'FILE_OPTIONS_FAILURE',

  FILES_SEARCH_REQUEST: 'FILES_SEARCH_REQUEST',
  FILES_SEARCH_SUCCESS: 'FILES_SEARCH_SUCCESS',
  FILES_SEARCH_FAILURE: 'FILES_SEARCH_FAILURE',

  GENERATE_FOLIO_REQUEST: 'GENERATE_FOLIO_REQUEST',
  GENERATE_FOLIO_SUCCESS: 'GENERATE_FOLIO_SUCCESS',
  GENERATE_FOLIO_FAILURE: 'GENERATE_FOLIO_FAILURE',

  SEARCH_GROUP_REQUEST: 'SEARCH_GROUP_REQUEST',
  SEARCH_GROUP_SUCCESS: 'SEARCH_GROUP_SUCCESS',
  SEARCH_GROUP_FAILURE: 'SEARCH_GROUP_FAILURE',

  GET_ACTORS_REQUEST: 'GET_ACTORS_REQUEST',
  GET_ACTORS_SUCCESS: 'GET_ACTORS_SUCCESS',
  GET_ACTORS_FAILURE: 'GET_ACTORS_FAILURE',

  GROUP_NAME_REQUEST: 'GROUP_NAME_REQUEST',
  GROUP_NAME_SUCCESS: 'GROUP_NAME_SUCCESS',
  GROUP_NAME_FAILURE: 'GROUP_NAME_FAILURE',

  REGISTER_ACTOR_REQUEST: 'REGISTER_ACTOR_REQUEST',
  REGISTER_ACTOR_SUCCESS: 'REGISTER_ACTOR_SUCCESS',
  REGISTER_ACTOR_FAILURE: 'REGISTER_ACTOR_FAILURE',

  START_ACTOR_REQUEST: 'START_ACTOR_REQUEST',
  START_ACTOR_SUCCESS: 'START_ACTOR_SUCCESS',
  START_ACTOR_FAILURE: 'START_ACTOR_FAILURE',

  REMOVE_ACTOR_REQUEST: 'REMOVE_ACTOR_REQUEST',
  REMOVE_ACTOR_SUCCESS: 'REMOVE_ACTOR_SUCCESS',
  REMOVE_ACTOR_FAILURE: 'REMOVE_ACTOR_FAILURE',

  UPDATE_ACTORS_REQUEST: 'UPDATE_ACTORS_REQUEST',
  UPDATE_ACTORS_SUCCESS: 'UPDATE_ACTORS_SUCCESS',
  UPDATE_ACTORS_FAILURE: 'UPDATE_ACTORS_FAILURE',

  MANUAL_CONFIGURATIONS_REQUEST: 'MANUAL_CONFIGURATIONS_REQUEST',
  MANUAL_CONFIGURATIONS_SUCCESS: 'MANUAL_CONFIGURATIONS_SUCCESS',
  MANUAL_CONFIGURATIONS_FAILURE: 'MANUAL_CONFIGURATIONS_FAILURE',

  CONTINUE_STAGE_ACTOR_SELECTTION_REQUEST: 'CONTINUE_STAGE_ACTOR_SELECTTION_REQUEST',
  CONTINUE_STAGE_ACTOR_SELECTTION_SUCCESS: 'CONTINUE_STAGE_ACTOR_SELECTTION_SUCCESS',
  CONTINUE_STAGE_ACTOR_SELECTTION_FAILURE: 'CONTINUE_STAGE_ACTOR_SELECTTION_FAILURE',
  
  UPDATE_METADATA_REQUEST: 'UPDATE_METADATA_REQUEST',
  UPDATE_METADATA_SUCCESS: 'UPDATE_METADATA_SUCCESS',
  UPDATE_METADATA_FAILURE: 'UPDATE_METADATA_FAILURE',
  
  GETFILE_BY_FOLIO_REQUEST: 'GETFILE_BY_FOLIO_REQUEST',
  GETFILE_BY_FOLIO_SUCCESS: 'GETFILE_BY_FOLIO_SUCCESS',
  GETFILE_BY_FOLIO_FAILURE: 'GETFILE_BY_FOLIO_FAILURE',

  GENERATE_FOLIO_EXTERNO_REQUEST: 'GENERATE_FOLIO_EXTERNO_REQUEST',
  GENERATE_FOLIO_EXTERNO_SUCCESS: 'GENERATE_FOLIO_EXTERNO_SUCCESS',
  GENERATE_FOLIO_EXTERNO_FAILURE: 'GENERATE_FOLIO_EXTERNO_FAILURE',

  SURVEY_SEND_REQUEST: 'SURVEY_SEND_REQUEST',
  SURVEY_SEND_SUCCESS: 'SURVEY_SEND_SUCCESS',
  SURVEY_SEND_FAILURE: 'SURVEY_FAILURE',

  GET_SURVEY_REQUEST: 'GET_SURVEY_REQUEST',
  GET_SURVEY_SUCCESS: 'GET_SURVEY_SUCCESS',
  GET_SURVEY_FAILURE: 'GET_SURVEY_FAILURE',
}
